import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../hooks/useLocalStore.js';
import FJMenu from '../../common/components/FJMenu/FJMenu.jsx';
import { AI_GENERATOR_PHOTO_TAB_LIST } from '../../config/dataConfig/FJAIPhotoGeneratorData.js';
import FJActionAIPhotoGenerator from '../../redux/action/FJActionAIPhotoGenerator.js';
import FJAIPhotoGeneratorLeftContainer from './FJAIPhotoGeneratorLeft/container/FJAIPhotoGeneratorLeftContainer.jsx';
import FJAIPhotoGeneratorRightContainer from './FJAIPhotoGeneratorRight/container/FJAIPhotoGeneratorRightContainer.jsx';
import FJDropDownManager from '../../common/js/FJDropDownManager.js';

function FJAIPhotoGenerator() {
    useLocalStore();
    const dispatch = useDispatch();
    const tabIndex = useSelector(state => state.aiPhotoGenerator.tabIndex);

    const _onChangeTab = (item, index) => {
        dispatch(FJActionAIPhotoGenerator.changeTabIndexAction(item, index));
        FJDropDownManager.hideAll();
    };

    return (
        <>
            <FJMenu
                tabList={AI_GENERATOR_PHOTO_TAB_LIST}
                selectTab={tabIndex}
                onChangeTab={_onChangeTab}
                keyValue='text'
            />
            <FJAIPhotoGeneratorLeftContainer />
            <FJAIPhotoGeneratorRightContainer />
        </>
    );
}

export default FJAIPhotoGenerator;
